
































































































import CompanySheet from "@/components/company/CompanySheet.vue";
import PreselectTemplateCard from "@/components/partner/PreselectTemplateCard.vue";
import MNoContent from "@/components/utility/mmmint/MNoContent.vue";
import { PreselectTemplateKeysEnum } from "@/lib/enum/preselect-template-keys.enum";
import { RequestStatusEnum } from "@/lib/enum/request-status-enum";
import { IDialog } from "@/lib/interfaces/dialog.interface";
import { handleError } from "@/lib/utility/handleError";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { Reference } from "@/models/reference.entity";
import { IRepairEstimate, RepairEstimate } from "@/models/repair-estimate.entity";
import { ISharedContent, SharedContent } from "@/models/shared-content.entity";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { UserModule } from "@/store/modules/me-user.store";
import { PartnerModule } from "@/store/modules/partner";
import { mixins } from "vue-class-component";
import { Component, Prop, Ref, Watch } from "vue-property-decorator";

export enum RepairEstimateRequestSteps {
  FORM = "form",
  SEND_MAIL = "sendMail"
}

@Component({
  components: { PreselectTemplateCard, CompanySheet, MNoContent },
  filters: {}
})
export default class ReportRepairEstimateRequestDialog extends mixins(PermissionMixin) implements IDialog {
  readonly RepairEstimateRequestSteps = RepairEstimateRequestSteps;
  readonly PreselectTemplateKeysEnum = PreselectTemplateKeysEnum;

  @Ref("templateCard")
  templateCard!: PreselectTemplateCard;

  @Prop({ default: false }) value!: boolean;

  dialog: boolean = this.value;

  @Watch("value")
  onValueChange(val: boolean) {
    if (val) {
      this.costEstimateRequest.dateFormable = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toString();
    }
    this.dialog = val;
  }

  @Watch("dialog")
  onDialogChange(val: boolean) {
    this.$emit("input", val);
  }

  step = RepairEstimateRequestSteps.FORM;
  costEstimateRequest: IRepairEstimate = new RepairEstimate({}).setDefaultLineItems();
  sharedContent: ISharedContent = new SharedContent({ partnerId: this.partner.id });

  requestsLoading = false;

  get partner() {
    return PartnerModule.partner;
  }

  get report() {
    return PartnerModule.report;
  }

  get context() {
    return {
      repairEstimate: this.costEstimateRequest,
      sharedContent: this.sharedContent,
      partner: this.partner,
      report: this.report,
      url: { sharing: this.sharedContent.url }
    };
  }

  get validForm() {
    return this.costEstimateRequest.dateFormable && this.report.workshopCompanyId;
  }

  get myUserId() {
    return UserModule.userId;
  }

  async createRequests() {
    this.requestsLoading = true;
    if (this.costEstimateRequest.id) {
      throw new Error("Repair estimate request ID is already defined");
    }

    if (!this.report.workshopCompanyId) {
      throw new Error("Workshop company ID is not defined in the report");
    }

    if (!this.report.workShopCompany) {
      await this.report.fetchWorkshopEntity();
    }

    if (!this.report.workShopCompany) {
      throw new Error("Error loading workshop entity");
    }

    try {
      this.costEstimateRequest.seller = this.report.workShopCompany.invoiceParty;

      this.costEstimateRequest.refs = [];

      if (this.myUserId) {
        this.costEstimateRequest.assignees = [this.myUserId];
      }
      this.costEstimateRequest.refs.push(new Reference({ refId: this.report.id, refType: ResourceEnum.REPORT }));
      if (this.report.vehicleId) {
        this.costEstimateRequest.refs.push(
          new Reference({ refId: this.report.vehicleId, refType: ResourceEnum.VEHICLE })
        );
      }

      this.costEstimateRequest.partnerId = this.report.partnerId;
      this.costEstimateRequest.reportId = this.report.id;

      await this.costEstimateRequest.create();

      if (this.report.workShopCompany.activeSharedContent) {
        this.report.workShopCompany.activeSharedContent.addRef(
          new Reference({ refId: this.costEstimateRequest.id, refType: ResourceEnum.REPAIR_ESTIMATE }),
          true
        );
        this.sharedContent = this.report.workShopCompany.activeSharedContent;
      } else {
        this.sharedContent.reportId = this.report.id;
        this.sharedContent.companyIds = [this.report.workshopCompanyId];
        this.sharedContent.refs = [
          ...this.costEstimateRequest.refs,
          new Reference({ refId: this.report.id, refType: ResourceEnum.REPORT })
        ];
        if (this.costEstimateRequest.id) {
          this.sharedContent.refs.unshift(
            new Reference({ refId: this.costEstimateRequest.id, refType: ResourceEnum.REPAIR_ESTIMATE })
          );
        } else {
          throw new Error("Repair estimate request ID is not defined");
        }

        await this.sharedContent.create();
        this.report.workShopCompany.activeSharedContent = this.sharedContent;
        this.report.workShopCompany.sharedContent.push(this.sharedContent);
      }
      this.costEstimateRequest.sharedContent.push(this.sharedContent);
      this.report.repairEstimates.unshift(this.costEstimateRequest);

      this.$emit("create:sharedContent", this.sharedContent);
    } catch (e) {
      handleError(e);
    }
    this.requestsLoading = false;
    return {
      repairEstimate: this.costEstimateRequest,
      sharedContent: this.sharedContent
    };
  }

  async createAndClose() {
    const request = await this.createRequests();
    request.sharedContent.copyUrl();
    this.close();
  }

  async createReportAndSend() {
    await this.createRequests();
    this.step = RepairEstimateRequestSteps.SEND_MAIL;
  }

  async sendMail() {
    await this.templateCard?.send();
    await this.costEstimateRequest.updatePartial({
      status: RequestStatusEnum.REQUESTED
    });
    await this.costEstimateRequest.updateStatusLog();
    this.close();
  }

  async close() {
    this.dialog = false;
    this.reset();
  }

  open() {
    this.reset();
    this.dialog = true;
  }

  reset() {
    this.step = RepairEstimateRequestSteps.FORM;
    this.costEstimateRequest = new RepairEstimate({ partnerId: this.partner.id }).setDefaultLineItems();
    this.sharedContent = new SharedContent({ partnerId: this.partner.id });
  }
}
